export const environment = {
  production: false,
  eliquaRestURL: 'https://padu.uat.qivos.net/ci-padu-UAT/rest/v1/',
  clientName: 'padu',
};
